// extracted by mini-css-extract-plugin
export default {"name":"Header_name__T7W67","code":"Header_code__mETEA","item":"Header_item__C3Q+n"};